import Servico from './Servico'

class FormularioServico extends Servico {
  constructor() {
    super('formulario')
  }

  duplicar(formulario) {
    const formularioCopia = {
      ...formulario,
      nome: formulario.nome + ' - Cópia',
    }

    delete formularioCopia._id

    for (const grupoQuestoes of formularioCopia.gruposQuestoes) {
      delete grupoQuestoes.id
    }

    this.criar(formularioCopia)
  }
}

export default FormularioServico
